import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode()
const _hoisted_2 = { key: 0 }

import { Tag } from '@/models/tag';
import TagWrapper from './TagWrapper.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    tag: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TagWrapper, {
      value: __props.tag.name
    }, null, 8, ["value"]),
    _hoisted_1,
    (__props.tag.post_tags_aggregate)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(" + _toDisplayString(__props.tag.post_tags_aggregate.aggregate.count) + ")", 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})